import { Box } from '@mui/material';
import { CSSProperties } from 'react';
import { CommonIcon, CommonIconProps } from './CommonIcon';

export type CategoryIconProps = {
    icon: string;
    iconColor?: string;
    customIcon?: string | null;
    size: number;
    type?: CommonIconProps['type'];
    color?: string;
    style?: CSSProperties;
    sx?: CommonIconProps['sx'];
};

export const CategoryIcon = ({ 
    icon, 
    iconColor: _iconColor, 
    customIcon, 
    size, 
    type = 'filled', 
    color,
    style,
    sx
}: CategoryIconProps) => {
    const iconDisplayColor = color || 'var(--tg-theme-text-color)';

    if (customIcon) {
        return (
            <Box
                component="img"
                src={customIcon}
                alt=""
                style={style}
                sx={{
                    width: `${size*1.3}px`,
                    height: `${size*1.3}px`,
                    borderRadius: '4px',
                    objectFit: 'cover',
                    ...sx,
                }}
            />
        );
    }

    return (
        <CommonIcon
            icon={icon}
            type={type}
            color={iconDisplayColor}
            size={size}
            style={style}
            sx={sx}
        />
    );
};
